import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';

import { SharedModule } from "../../shared/shared.module";
import { ParametrizacaoRoutingModule } from './parametrizacao-routing.module';
import { ParametrizacaoImpedimentoComponent } from './parametrizacao-impedimento/parametrizacao-impedimento.component';



@NgModule({
    imports: [
      SharedModule
    ],
    declarations: [
        ParametrizacaoImpedimentoComponent
      
    ],
    exports: [
        ParametrizacaoRoutingModule
    ],
    providers: [
        DatePipe,
    ]
})
export class ParametrizacaoModule { }
